/** Voice/video call protocol scaffold — H8 / ADR 0004 */

export const CONTENT_TYPE_CALL = 11;

export type CallSignalOp =
  | { op: "call-invite"; callId: string; media: "audio" | "video"; sdp: string }
  | { op: "call-accept"; callId: string; sdp: string }
  | { op: "call-reject"; callId: string; reason?: string }
  | { op: "call-hangup"; callId: string }
  | { op: "call-ice"; callId: string; candidate: string };

export const CALL_FEATURE_STATUS = {
  signaling: "partial",
  mediaE2ee: "absent",
  insertableStreams: "absent",
  availableInUi: false,
  gateMessage:
    "Calls aren't available yet — voice and video stay disabled until end-to-end encrypted media is ready.",
} as const;

export function encodeCallSignal(op: CallSignalOp): string {
  return JSON.stringify(op);
}

export function decodeCallSignal(body: string): CallSignalOp | null {
  try {
    const raw = JSON.parse(body) as CallSignalOp;
    if (!raw || typeof raw !== "object" || !("op" in raw)) return null;
    return raw;
  } catch {
    return null;
  }
}
